/* eslint-disable jsx-a11y/anchor-is-valid */
import { useQueryRequest } from '@/app/modules/report-trend-analysis/core/QueryRequestProvider'
import React from 'react'
import { FormattedNumber, IntlProvider } from 'react-intl'
import {
  useAreaQueryResponseData,
  useAreaQueryResponseLoading,
} from '../core/QueryResponseAreaProvider'

type Props = {
  className: string
}

const TopArea: React.FC<Props> = ({className}) => {
  const {state} = useQueryRequest()
  const data = useAreaQueryResponseData()
  const isLoading = useAreaQueryResponseLoading()
  const firstFiveData = data && data.slice(0, 5)

  const getGrowthClass = (value?: number | null) => {
    if (typeof value !== 'number') {
      return 'text-dark'
    }

    if (value > 0) {
      return 'text-success'
    }

    if (value < 0) {
      return 'text-danger'
    }

    return 'text-dark'
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>
            Top 5 Area - {(state.sub_brand_name && state.sub_brand_name?.[0]) || 'OIC'}
          </span>
        </h3>
        <div
          className='card-toolbar'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Click to add a user'
        ></div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body shadow-wit-2 py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-30px'>No</th>
                <th className='min-w-100px'>Area</th>
                <th className='min-w-100px'>Total Transaction</th>
                <th className='min-w-100px'>Total Transaction Value</th>
                <th className='min-w-100px'>Total Transaction Value Last Year</th>
                <th className='min-w-100px'>YoY Growth %</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody className='text-dark mb-1 fs-6'>
              {isLoading ? (
                <tr>
                  <td colSpan={3} className='text-center py-10'>
                    <div className='spinner-border text-primary' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : (
                firstFiveData &&
                firstFiveData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <a href='#' className='text-dark fw-semibold text-hover-primary d-block fs-6'>
                        {index + 1}
                      </a>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold fs-6'>{item.outlet_name}</span>
                        </div>
                      </div>
                    </td>
                    <td className='text-end'>
                      <div className='d-flex flex-column w-100 me-2'>
                        <div className='d-flex flex-stack mb-2'>
                          <span className='text-dark me-2 fs-7 fw-semibold'>
                            <IntlProvider locale='id'>
                              <FormattedNumber value={item.total_transaction || 0} />
                            </IntlProvider>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className='text-end'>
                      <div className='d-flex flex-column w-100 me-2'>
                        <div className='d-flex flex-stack mb-2'>
                          <span className='text-dark me-2 fs-7 fw-semibold'>
                            Rp.{' '}
                            <IntlProvider locale='id'>
                              <FormattedNumber value={item.total_transaction_value || 0} />
                            </IntlProvider>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className='text-end'>
                      <div className='d-flex flex-column w-100 me-2'>
                        <div className='d-flex flex-stack mb-2'>
                          <span className='text-dark me-2 fs-7 fw-semibold'>
                            Rp.{' '}
                            <IntlProvider locale='id'>
                              <FormattedNumber
                                value={item.total_transaction_value_last_year || 0}
                              />
                            </IntlProvider>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className='text-end'>
                      <div className='d-flex flex-column w-100 me-2'>
                        <div className='d-flex flex-stack mb-2'>
                          <span className={`${getGrowthClass(item.yoy_growth)} me-2 fs-7 fw-semibold`}>
                            <IntlProvider locale='id'>
                              <FormattedNumber value={item.yoy_growth || 0} />
                            </IntlProvider>
                            %
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export { TopArea }

